const AddressSelectorLanguage = {
	en: {
		placeholder: "zip code or city"
	},
	es: {
		placeholder: "código postal o ciudad"
	},
	ko: {
		placeholder: "kòd postal oswa vil"
	}
};
export default AddressSelectorLanguage;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/address-selector/address-selector.language.js